import * as React from 'react';

import styles from './FullScreenControls.css';
import { IVillageSchema } from '../../../types';

export interface IFullScreenControlsCommonProps {
  village: IVillageSchema;
}

export interface IFullScreenControlsOwnProps {
  exitFullscreen(): void;
}

type IProps = IFullScreenControlsCommonProps & IFullScreenControlsOwnProps;

export const FullScreenControls = ({ exitFullscreen, village }: IProps) => (
  <div className={styles['controls']}>
    <div className={styles['title']}>{village.name}</div>
    <div className={styles['close']} onClick={exitFullscreen} />
  </div>
);
